import { Utils, Enums } from '@wix/promotions-types';
import { HttpClient } from '@wix/yoshi-flow-editor';
import { getViewerEssentials } from '../../viewer-utils';
import { EditorSDKUtils } from '../editorSDKUtils';

export const getCampaigns = async ({
  editorSDK,
  instance,
  shouldUpdate,
}: {
  editorSDK?: any;
  instance?: string;
  shouldUpdate?: boolean;
}) => {
  shouldUpdate = shouldUpdate ? shouldUpdate : false;
  const httpClient = new HttpClient();
  if (editorSDK) {
    const editorSDKUtils = new EditorSDKUtils(editorSDK);
    instance = await editorSDKUtils.getInstance();
  }
  if (!instance) {
    return;
  }

  const { Apis } = Enums.getAutoApiEndpoints(getViewerEssentials().flowAPI);
  const campaigns = await Utils.DataItemApi(
    instance,
    httpClient,
  ).queryDataItems({ shouldUpdate }, Apis);

  return campaigns;
};
